import React from 'react';
import { Controller } from 'react-hook-form';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css'; // Importing styles for Datetime picker
import FormLabel from './FormLabel';
import { normalDateFormat } from '../../Helpers/dateTimeHelper';

const CustomInput = React.forwardRef((props, ref) => (
  <div className="input-group">
    <div className="input-group-prepend">
      <span className="input-group-text">
        <em className="fa fa-calendar-alt"></em>
      </span>
    </div>
    <input {...props} ref={ref} />
  </div>
));

const FormDateTime = ({ control, name, id, label, rules, placeholder, ...props }) => (
  <div id={id}>
    {label && <FormLabel rules={rules} label={label} />}
    <Controller
      id={id}
      name={name}
      control={control}
      rules={rules}
      defaultValue=""
      render={({ field, fieldState }) => (
        <div>
          <Datetime
            value={field.value}
            onChange={(date) => field.onChange(date)}
            onBlur={field.onBlur}
            timeFormat={false}
            renderInput={(inputProps) => (
              <CustomInput ref={field.ref} {...field} {...inputProps} placeholder={placeholder || normalDateFormat} />
            )}
            {...props}
          />
          {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
        </div>
      )}
    />
  </div>
);

export default FormDateTime;
